import { AnimatePresence, motion } from "framer-motion";
import type { ConverterTheme } from "./types";

interface ProgressBarProps {
  isVisible: boolean;
  progress: number;
  theme: ConverterTheme;
}

const ProgressBar = ({ isVisible, progress, theme }: ProgressBarProps) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="h-2 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800"
      >
        <motion.div
          className={`h-full rounded-full bg-gradient-to-r ${theme.progressBar}`}
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ ease: "easeOut" }}
        />
      </motion.div>
    )}
  </AnimatePresence>
);

export default ProgressBar;
